
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateAllMetadata, getRouteMetadata, PageMetadata } from '../utils/dynamicMetadata';
import { initMetadataRefresher } from '../utils/metadataRefresher';
import { checkNeedsUpdate } from '../utils/versionControl';

interface MetadataProviderProps {
  children: ReactNode;
  customMetadata?: PageMetadata;
}

export function MetadataProvider({ children, customMetadata }: MetadataProviderProps) {
  const location = useLocation();
  
  useEffect(() => {
    // Check if app needs update
    const needsUpdate = checkNeedsUpdate();
    
    // Initialize the metadata refresher
    const { refreshMetadata, observer } = initMetadataRefresher();
    
    // Only refresh metadata, don't force update
    // Use a moderate timeout to ensure DOM is ready
    setTimeout(refreshMetadata, 300);
    
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  
  useEffect(() => {
    const routeMetadata = getRouteMetadata(location.pathname);
    const mergedMetadata = {
      ...routeMetadata,
      ...(customMetadata || {})
    };
    updateAllMetadata(mergedMetadata);
  }, [location.pathname, customMetadata]);
  
  return <>{children}</>;
}

export default MetadataProvider;
